export default __webpack_public_path__ + "static/media/2.b09800d1.png";